export default __webpack_public_path__ + "static/media/gallery_19.28bd173c.jpg";